import {Component, HostListener,
  CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {LaunchDialogService} from '@spartacus/storefront';
import {AutofocusDirective} from '../../../directives/autofocus/autofocus.directive';
import {TranslatePipe} from '@spartacus/core';

@Component({
  selector: 'dcp-cc-restricted-country-iframe',
  templateUrl: './cc-restricted-country-iframe.component.html',
  styleUrls: ['./cc-restricted-country-iframe.component.scss'],
  imports: [AutofocusDirective, TranslatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CcRestrictedCountryIframeComponent {
  sapComUrl = 'https://www.sap.com/registration/trial.908cb719-0e03-421c-a091-daca045f0acc.html';

  constructor(protected launchDialogService: LaunchDialogService) {}

  @HostListener('document:keydown.escape')
  @HostListener('click')
  handleClickOrEsc(): void {
    this.launchDialogService.closeDialog('Cross click');
  }

  close(reason: string): void {
    this.launchDialogService.closeDialog(reason);
  }
}
